import { IProject, IProduct } from 'shared/interfaces'

export const sortProductsByReleaseDate = (products: IProduct[]): IProduct[] =>
  [...products].sort((product1, product2) => {
    if (Date.parse(product1.publish_date) < Date.parse(product2.publish_date)) return 1
    if (Date.parse(product1.publish_date) > Date.parse(product2.publish_date)) return -1

    return 0
  })

export const findMainProduct = (
  campaign: IProject,
  products: IProduct[],
  activeProductId?: number
): {
  index: number
  id: string
} => {
  const mainProduct = products.find((product) =>
    activeProductId
      ? product.id === activeProductId.toString()
      : campaign?.main_product_id && product.id === campaign.main_product_id.toString()
  )

  if ((!campaign.main_product_id && !activeProductId) || !mainProduct) return { index: 0, id: '' }

  return {
    index: products.indexOf(mainProduct),
    id: mainProduct.id
  }
}
